// import * as Sentry from '@sentry/browser';
import * as Sentry from '@sentry/react';
import {
  beforeSend,
  SENTRY_DENY_URLS,
  SENTRY_IGNORE_ERRORS,
} from './sentryFilters';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    replaysSessionSampleRate: 0,

    replaysOnErrorSampleRate: 1.0,

    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],

    // Sample 10% of transactions for performance tracing.
    // Increase toward 1.0 once quota impact is assessed.
    tracesSampleRate: 0.1,

    // Propagate sentry-trace headers to same-origin requests and the configured backend.
    // /^\/\// covers same-origin API calls (e.g. dev reverse-proxy setup).
    // The Apollo URI hostname is included so cross-origin backends (e.g. be.scientificseminars.it)
    // also receive the sentry-trace header — derived automatically from REACT_APP_APOLLO_URI
    // so no extra env vars are needed and it stays in sync with the actual backend.
    tracePropagationTargets: (() => {
      const targets: (string | RegExp)[] = ['localhost', /^\//];
      const apolloUri = process.env.REACT_APP_APOLLO_URI;
      if (apolloUri) {
        try {
          targets.push(new URL(apolloUri).hostname);
        } catch (_) {
          // malformed URI — fall back to same-origin only
        }
      }
      return targets;
    })(),

    ignoreErrors: SENTRY_IGNORE_ERRORS,
    denyUrls: SENTRY_DENY_URLS,
    beforeSend,
  });
}
